import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PipeTransform } from '@angular/core';
import { ModelDto } from '@dto/modelDto';
import { Model } from '@models/model';
import { ModelTableEntry } from '@dto/ModelTableEntry'
import { Observable } from 'rxjs';
import { Setting } from '../../models/setting';
import { EntityService } from './entity.service';

@Injectable({
  providedIn: 'root'
})

export class ModelsService extends EntityService {

  public entityRoute = "models";

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);
  }

  static matches(model: ModelDto, term: string, pipe?: PipeTransform) {
    return model.name.toLowerCase().includes(term.toLowerCase()) ||
      model.manufacturer.name.toLowerCase().includes(term.toLowerCase())
  }

  getModel(id:number): Observable<ModelDto> {
    return this.http.get<ModelDto>(this.baseUrl + 'api/models/'+id);
  }


  getAllModels(): Observable<ModelTableEntry[]> {
    return this.http.get<ModelTableEntry[]>(this.baseUrl + 'api/models/all');
  }

  getCountOfModels(): Observable<number> {
    return this.http.get<number>(this.baseUrl + 'api/models/count')
  }

  createModel(model: ModelDto): Observable<ModelDto> {
    return this.http.post<ModelDto>(this.baseUrl + 'api/models/create', model);
  }

  patchModel(model: ModelDto): Observable<ModelDto> {
    return this.http.patch<ModelDto>(this.baseUrl + 'api/models/update', model);
  }
}
